import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ChecklistItem } from '../___common/__interfaces/ChecklistItem';
import { GroupedChecklist } from '../___common/__interfaces/GroupedChecklist';
import { HttpHeaders } from '@angular/common/http';

const HTTP_OPTIONS = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  selectedClientId;
  currentTokenOrderCode;

  constructor(private domSanitizer: DomSanitizer) { }

  __HTTP_OPTIONS(){
    return HTTP_OPTIONS;
  }

  getCurrentToken(){
    return this.currentTokenOrderCode;
  }

  sewtCurrentToken(token){
    this.currentTokenOrderCode = token;
  }
  
  convertUrl( url: string) {
    let new_url;
    new_url = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    return new_url;
  }

  calculateDurationInMonthsAndDays(startDate, endDate) {
    // Parse the start and end dates
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    // Calculate the differences in years, months, and days
    let yearsDifference = end.getFullYear() - start.getFullYear();
    let monthsDifference = end.getMonth() - start.getMonth();
    let daysDifference = end.getDate() - start.getDate();
  
    // Adjust months and days if necessary
    if (daysDifference < 0) {
      // Get the number of days in the month prior to the end date month
      const monthBeforeEnd = new Date(end.getFullYear(), end.getMonth(), 0);
      const daysInMonthBeforeEnd = monthBeforeEnd.getDate();
  
      daysDifference += daysInMonthBeforeEnd;
      monthsDifference--;
    }
    if (monthsDifference < 0) {
      monthsDifference += 12;
      yearsDifference--;
    }
  
    // Convert the total difference to months and days
    const totalMonths = yearsDifference * 12 + monthsDifference;
  
    return `${totalMonths} meses, ${daysDifference} días`;
  }

  arrayHasElement(array: any[], element: any) {
    let   arrayHasElemetIndexCache = null;
    for (let [index,obj] of array.entries()) {
      if (obj === element) {
        arrayHasElemetIndexCache = index;
        return true;
      }
    }
    arrayHasElemetIndexCache = -1;
    return false;
  }

  groupChecklists(data: ChecklistItem[]) {
    let groups = data.reduce((acc, item) => {
      const group = acc.find(g => g.checklist_id === item.checklist_id);
      if (group) {
        group.items.push(item);
      } else {
        acc.push({
          checklist_id: item.checklist_id,
          name: item.name,
          items: [item]
        });
      }
      return acc;
    }, [] as GroupedChecklist[]);
    return groups;
  }


  getSelectedClientId() : number | null{
    return this.selectedClientId;
  }

  isUserLoggedIn(){
    return this.selectedClientId != null;
  }

  setSelectedClientId(id){
    this.selectedClientId = id;
  }

  generateRandomNumber(){
    return Date.now() + Math.floor(Math.random() * 100);
  }
} 
